import { Directive, ElementRef, Input, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[appTruncateTooltip]',
  standalone: true
})
export class TruncateTooltipDirective implements OnInit, OnDestroy {
  @Input() appTruncateTooltip: string = '';
  @Input() ariaLabel: string = '';
  @Output() showCustomTooltip = new EventEmitter<{ text: string; x: number; y: number; tooltipClass?: string }>();
  @Output() hideCustomTooltip = new EventEmitter<void>();

  private resizeObserver: ResizeObserver | null = null;
  private isTruncated = false;

  constructor(private el: ElementRef) {}

  ngOnInit() {
    this.checkTruncation();
    this.setupResizeObserver();
    this.el.nativeElement.setAttribute('aria-label', this.ariaLabel || this.appTruncateTooltip);
    this.setupTooltipListeners();
  }

  ngOnDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  private checkTruncation() {
    const element = this.el.nativeElement;
    this.isTruncated = element.scrollWidth > element.clientWidth;
  }

  private setupResizeObserver() {
    this.resizeObserver = new ResizeObserver(() => {
      this.checkTruncation();
    });
    this.resizeObserver.observe(this.el.nativeElement);
  }

  private setupTooltipListeners() {
    this.el.nativeElement.addEventListener('mouseenter', () => this.onMouseEnter());
    this.el.nativeElement.addEventListener('mouseleave', () => this.onMouseLeave());
  }

  private onMouseEnter() {
    if (this.isTruncated && this.appTruncateTooltip) {
      const rect = this.el.nativeElement.getBoundingClientRect();
      this.showCustomTooltip.emit({
        text: this.appTruncateTooltip,
        x: rect.left - 310,
        y: rect.top,
        tooltipClass: 'savings-reason-tooltip'
      });
    }
  }

  private onMouseLeave() {
    this.hideCustomTooltip.emit();
  }
}
